module.exports = __webpack_public_path__ + "static/img/index-bg1.dec2c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-bg1.png
// module id = V8bv
// module chunks = 1